import { render, staticRenderFns } from "./KatexMarkdown.vue?vue&type=template&id=0a78568c&scoped=true"
import script from "./KatexMarkdown.vue?vue&type=script&lang=js"
export * from "./KatexMarkdown.vue?vue&type=script&lang=js"
import style0 from "./KatexMarkdown.vue?vue&type=style&index=0&id=0a78568c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a78568c",
  null
  
)

export default component.exports